import PropTypes from 'prop-types';
import { OutlineButton, Flex, Box, Icon, Text } from '@qga/roo-ui/components';
import { themeGet } from '@styled-system/theme-get';
import styled from '@emotion/styled';
import { ShowOnLargeScreen, ShowOnSmallScreen } from 'components/Layout';
import { Link } from 'components/Typography';
import ConfirmationButton from '../ConfirmationButton';
import noop from 'lodash/noop';

const ManageBookingLink = styled(Link)`
  font-size: ${themeGet('fontSizes.lg')};
  color: ${themeGet('colors.ui.link')};
`;

ManageBookingLink.displayName = 'ManageBookingLink';

const ManageBookingButton = styled(OutlineButton)`
  &:hover {
    color: white;
  }
`;
ManageBookingButton.displayName = 'ManageBookingButton';

const ActionBar = ({ backLinkUrl, onClickBackLink }) => (
  <Box mb={[1, 2]}>
    <Flex justifyContent={['flex-start', 'space-between']} flexDirection={['column', 'row']} alignItems="center">
      <ShowOnLargeScreen>
        <ManageBookingLink to={backLinkUrl} underline onClick={onClickBackLink}>
          <Icon name="arrowBack" mr={2} />
          <Text>Manage your booking</Text>
        </ManageBookingLink>
      </ShowOnLargeScreen>

      <ConfirmationButton width={['100%', 'auto']} />

      <ShowOnSmallScreen>
        <ManageBookingButton as={Link} to={backLinkUrl} onClick={onClickBackLink} variant="primary" block mt={5}>
          Manage your booking
        </ManageBookingButton>
      </ShowOnSmallScreen>
    </Flex>
  </Box>
);

ActionBar.defaultProps = {
  onClickBackLink: noop,
};

ActionBar.propTypes = {
  backLinkUrl: PropTypes.string.isRequired,
  onClickBackLink: PropTypes.func,
};

export default ActionBar;
